// actions types used in doctors page are defined here
export const GET_MY_TIMESLOTS = 'GET_MY_TIMESLOTS';
export const GET_MY_TIMESLOTS_SUCCESS = 'GET_MY_TIMESLOTS_SUCCESS';
export const GET_MY_TIMESLOTS_FAILED = 'GET_MY_TIMESLOTS_FAILED';

export const ADD_THIS_TIME_SLOT = 'ADD_THIS_TIME_SLOT';

export const DELETE_THIS_TIME_SLOT = 'DELETE_THIS_TIME_SLOT';
